// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".highlighter-wrapper__highlight_b616557d{background-color:rgba(64,194,201,0.2)}.highlighter-wrapper__clickable_c2af0b2b{cursor:pointer}.highlighter-wrapper__clickable_c2af0b2b:hover{transition:background-color .2s;background-color:#dceffa}", ""]);
// Exports
export var highlighterWrapperHighlight = "highlighter-wrapper__highlight_b616557d";
export var highlighterWrapperClickable = "highlighter-wrapper__clickable_c2af0b2b";
export default ___CSS_LOADER_EXPORT___;
